import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './mayzamoreira_lashdesign.module.scss';
import BackgroundLinks from './src/background-links.png';
import LinkWhatsapp from './src/1.png';
import LinkProcedimentos from './src/2.png';
import LinkCurso from './src/3.png';
import LinkLocalizacao from './src/4.png';

const MARQUEE_PHRASE = 'MAYZA MOREIRA • ';
const MARQUEE_TEXT = MARQUEE_PHRASE.repeat(24);
const MARQUEE_COPIES = 4;
const MAPS_URL = 'https://maps.app.goo.gl/qL368NV5VDUWpgpk7';

const Mayzamoreira_lashdesign: React.FC = () => {
    const trackRef = useRef<HTMLUListElement>(null);
    const [showLocation, setShowLocation] = useState(false);

    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;

        const handleVisibility = () => {
            track.style.animationPlayState = document.hidden ? 'paused' : 'running';
        };

        document.addEventListener('visibilitychange', handleVisibility);
        return () => document.removeEventListener('visibilitychange', handleVisibility);
    }, []);

    useEffect(() => {
        if (!showLocation) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setShowLocation(false);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [showLocation]);

    return (
        <div className={styles.mayzamoreira_lashdesign}>
            <div className={styles.main}>
                <img
                    className={styles.cardImage}
                    src={BackgroundLinks}
                    alt="Mayza Moreira — cartão digital"
                    decoding="async"
                />

                <div className={styles.marqueeContainer} aria-hidden>
                    <section className={styles.marqueeSection}>
                        <ul className={styles.marqueeTrack} ref={trackRef}>
                            {Array.from({ length: MARQUEE_COPIES }, (_, index) => (
                                <li
                                    key={index}
                                    className={styles.marqueeSlide}
                                    aria-hidden={index > 0}
                                >
                                    <div className={styles.marqueeItem}>
                                        <p className={styles.marqueeText}>{MARQUEE_TEXT}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </section>
                </div>
                <div className={styles.content}>
                    <a href="https://wa.me/5532998055394?text=Olá, tudo bem? Vim pelo Instagram e gostaria de informações..." className={styles.contentLink}>
                        <img
                            className={styles.contentImage}
                            src={LinkWhatsapp}
                            alt="Whatsapp — clique para saber mais"
                            decoding="async"
                        />
                    </a>
                    <Link to="/mayzamoreira_lashdesign/procedimentos" className={styles.contentLink}>
                        <img
                            className={styles.contentImage}
                            src={LinkProcedimentos}
                            alt="Procedimentos — clique para saber mais"
                            decoding="async"
                        />
                    </Link>
                    <Link to="/mayzamoreira_lashdesign/curso" className={styles.contentLink}>
                        <img
                            className={styles.contentImage}
                            src={LinkCurso}
                            alt="Curso — clique para saber mais"
                            decoding="async"
                        />
                    </Link>
                    <button
                        type="button"
                        className={styles.contentLink}
                        onClick={() => setShowLocation(true)}
                    >
                        <img
                            className={styles.contentImage}
                            src={LinkLocalizacao}
                            alt="Localização — clique para saber mais"
                            decoding="async"
                        />
                    </button>
                </div>
            </div>

            {showLocation && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setShowLocation(false)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="mayza-location-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setShowLocation(false)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>
                        <p className={styles.modalEyebrow}>Studio</p>
                        <h2 id="mayza-location-title" className={styles.modalTitle}>
                            Localização
                        </h2>
                        <address className={styles.modalAddress}>
                            <p>Rua Marechal Deodoro, 360</p>
                            <p>Galeria João Pedro Hallack</p>
                            <p className={styles.modalHint}>
                                Entrada ao lado da O Boticário
                            </p>
                            <p>1º andar — Sala 101</p>
                            <p className={styles.modalCity}>Juiz de Fora — MG</p>
                        </address>
                        <a
                            href={MAPS_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.modalMapsBtn}
                        >
                            Abrir no Maps
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Mayzamoreira_lashdesign;
